<template>
  <div class="copyright">
    Copyright ©2025 深圳市赛鹏标准信息服务有限公司 版权所有

    <span @click="click" style="cursor: pointer"
      >备案号：粤ICP备2025398064号-1</span
    >
  </div>
</template>

<script>
export default {
  methods: {
    click() {
      window.open("https://beian.miit.gov.cn/");
    },
  },
};
</script>

<style scoped>
.copyright {
  position: fixed;
  width: 100%;
  bottom: 0;
  text-align: center;
  margin: 0 auto;
  padding: 10px 20px;
  color: #666;
  font-size: 14px;
  z-index: 999;
}
</style>
